function areParenthesesBalanced(urlText) {
    let openParens = 1;
    let closeParens = 0;
    for (const char of urlText){
        if ('(' === char) openParens++;
        if (')' === char) closeParens++;
    }
    return openParens === closeParens;
}
function hasIncompleteUrl(textAfterClosingBracket) {
    if (!textAfterClosingBracket.startsWith('(')) return true;
    const urlText = textAfterClosingBracket.substring(1);
    return !areParenthesesBalanced(urlText);
}
function extractLinkText(lastBracketIndex, markdown) {
    const textAfterBracket = markdown.substring(lastBracketIndex + 1);
    const closingBracketIndex = textAfterBracket.indexOf(']');
    if (-1 === closingBracketIndex) return textAfterBracket;
    const linkText = textAfterBracket.substring(0, closingBracketIndex);
    const textAfterClosingBracket = textAfterBracket.substring(closingBracketIndex + 1);
    if (hasIncompleteUrl(textAfterClosingBracket)) return linkText;
    return '';
}
function processIncompleteLinks(markdown) {
    if (!markdown) return '';
    const lastBracketIndex = markdown.lastIndexOf('[');
    if (-1 === lastBracketIndex) return markdown;
    const linkText = extractLinkText(lastBracketIndex, markdown);
    if (linkText) {
        const processedMarkdown = markdown.substring(0, lastBracketIndex) + linkText;
        return processedMarkdown.replace(/https?:\/\/[^\s)]+$/g, '');
    }
    return markdown.replace(/https?:\/\/[^\s)]+$/g, '');
}
function processPhoneNumbers(markdown, customerSupportNumber, onPhoneNumberDisplayed) {
    if (!markdown) return '';
    return markdown.replace(/(?<![a-zA-Z0-9@])(1?[-.]?\d{3}[-.]?\d{3}[-.]?\d{4})(?![a-zA-Z0-9@])/g, (match, phoneNumber, offset, string)=>{
        const textBeforeMatch = string.substring(0, offset);
        const textAfterMatch = string.substring(offset + match.length);
        const lastProtocolIndex = textBeforeMatch.lastIndexOf('://');
        if (-1 !== lastProtocolIndex) {
            const urlStart = lastProtocolIndex;
            const textAfterProtocol = string.substring(urlStart + 2, offset + match.length);
            if (textAfterProtocol && !/\s/.test(textAfterProtocol)) return match;
        }
        const lastCharBeforeMatch = textBeforeMatch[textBeforeMatch.length - 1];
        const firstCharAfterMatch = textAfterMatch[0];
        if (lastCharBeforeMatch?.match(/[a-zA-Z0-9@]/) || firstCharAfterMatch?.match(/[a-zA-Z0-9@]/)) return match;
        if (phoneNumber === customerSupportNumber && onPhoneNumberDisplayed && 'function' == typeof onPhoneNumberDisplayed) onPhoneNumberDisplayed();
        const cleanNumber = phoneNumber?.replace(/\D/g, '');
        return `[${phoneNumber}](tel:${cleanNumber})`;
    });
}
export { processIncompleteLinks, processPhoneNumbers };
